/**
 * Centralized domain constants for Yardzen applications
 */

export const DOMAINS = {
  PRODUCTION: "https://yardzen.com",
  STAGING: "https://staging.yardzen.com",
} as const;

/**
 * Get the appropriate Yardzen domain based on the current environment
 */
export function getYardzenDomain(): string {
  return process.env.NODE_ENV === "production"
    ? DOMAINS.PRODUCTION
    : DOMAINS.STAGING;
}

/**
 * Redirect to packages page on the appropriate Yardzen domain
 */
export function redirectToPackages(): void {
  const hostUrl = getYardzenDomain();
  window.location.href = `${hostUrl}/packages`;
}

/**
 * Get URL for a specific path on the Yardzen domain
 */
export function getYardzenUrl(path: string): string {
  const hostUrl = getYardzenDomain();
  return `${hostUrl}${path.startsWith("/") ? path : `/${path}`}`;
}
